import { Store } from './store';
import { Status } from './status';
import { OrderTotal } from './order-total';
import { OrderNumber } from './order-number';
import { OrderDate } from './order-date';
import { ItemsCount } from './items-count';

export const customersOrdersGrid = [Store, OrderNumber, OrderDate, ItemsCount, OrderTotal, Status];
